import CompanionMaterialItem from '@/models/CompanionMaterialItem';
import CompanionMaterialItemConstants from '../CompanionMaterialItemConstants';
import ICompanionMaterialConversionHandler from './ICompanionMaterialConversionHandler';

class RulerCompanionMaterialConversionHandler implements ICompanionMaterialConversionHandler {
  execute(companionMaterialItem: CompanionMaterialItem): Map<string, unknown> {
    const map: Map<string, unknown> = new Map();

    if (companionMaterialItem && companionMaterialItem.name === CompanionMaterialItemConstants.RULER) {
      map.set('ruler', true);
    }

    return map;
  }
}

export default RulerCompanionMaterialConversionHandler;
